const validateDomiciliation = "validateDomiciliation";
const domiciliationCreate = "create";

import { ClaroSDKService } from "../sdk/ClaroSDKService";

export const DomiciliationApi = {
  async getHasDomiciliationService(reference, username, serviceId) {
    const { REACT_APP_DOMICILIATION_API_URL, REACT_APP_DOMICILIATION_API_KEY } =
      process.env;
    const { access_token: accessToken = false } =
      await ClaroSDKService.getFullToken();
    const headers = new Headers({
      "Content-Type": "application/json",
      "x-api-key": REACT_APP_DOMICILIATION_API_KEY,
    });
    if (accessToken) {
      headers.append("Authorization", `Bearer ${accessToken}`);
    }

    return new Promise((resolve, reject) => {
      fetch(
        `${REACT_APP_DOMICILIATION_API_URL}/${validateDomiciliation}?claroId=${username}&serviceId=${serviceId}&reference=${reference}`,
        {
          method: "GET",
          headers,
        },
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          console.log("Has domiciliation success");
          return resolve(data);
        })
        .catch(function (err) {
          console.log("Has domiciliation error");
          reject(err);
        });
    }).catch((e) => {
      console.log(e, "Has domiciliation catch error");
      throw e;
    });
  },

  async domiciliationAccountService(
    authorizationTyC,
    claroId,
    detail,
    dueDate,
    expirationDate,
    externalId,
    initialDay,
    maxAmount,
    msisdn,
    msisdnCipher,
    periodicity,
    pin,
    productId,
    reference,
    serviceHolder,
    serviceId,
  ) {
    const { REACT_APP_DOMICILIATION_API_URL, REACT_APP_DOMICILIATION_API_KEY } =
      process.env;
    const dataBodyRequest = {
      authorizationTyC,
      claroId,
      detail,
      dueDate,
      expirationDate,
      externalId,
      initialDay,
      maxAmount,
      msisdn,
      msisdnCipher,
      periodicity,
      pin,
      productId,
      reference,
      serviceHolder,
      serviceId,
    };
    const { access_token: accessToken = false } =
      await ClaroSDKService.getFullToken();
    const headers = new Headers({
      "Content-Type": "application/json",
      "x-api-key": REACT_APP_DOMICILIATION_API_KEY,
    });
    if (accessToken) {
      headers.append("Authorization", `Bearer ${accessToken}`);
    }

    return new Promise((resolve, reject) => {
      fetch(`${REACT_APP_DOMICILIATION_API_URL}/${domiciliationCreate}`, {
        method: "POST",
        headers,
        body: JSON.stringify(dataBodyRequest),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          console.log("Domiciliation success");
          return resolve(data);
        })
        .catch(function (err) {
          console.log("Domiciliation error");
          reject(err);
        });
    }).catch((e) => {
      console.log(e, "Domiciliation catch error");
      throw e;
    });
  },
};
